import api from '@/services/api';

export default {
  async redirectToCommunities(tag) {
      try {  
        let response = await api.get(`Help/Communities?tag=${tag}`);
        window.open(response.data, '_blank');
      } catch (ex) {
        console.error(ex);
        return null;
      }
  }
}
